// Renaming / retyping an existing zone — the rules the editor checks before a save.
//
// A zone keeps its identity across a rename (backend applicaite/zone_identity.py):
// its history, actions, promos, goals and links follow it. The one hard rule is that
// two zones on ONE camera may not share a name — the camera box tells zones apart by
// name, and the server refuses the save (409).

import { i18n } from '@/i18n'
import { zoneTypeLabel } from '@/i18n/zoneTypes'

const t = (key, params) => i18n.global.t(`zoneSettings.identity.${key}`, params)

export const norm = (s) => String(s ?? '').trim().toLowerCase()

export function validateZoneIdentity({ name, type, takenNames = [] }) {
  const n = String(name ?? '').trim()
  if (!n) return { ok: false, error: t('nameRequired') }
  if (!type) return { ok: false, error: t('typeRequired') }
  if (takenNames.some((t) => norm(t) === norm(n))) {
    return { ok: false, error: t('nameTaken', { name: n }) }
  }
  return { ok: true, error: null }
}

// The line shown under the fields while editing, or null when nothing changed.
export function describeChange({ name, type, originalName, originalType }) {
  const parts = []
  const n = String(name ?? '').trim()
  if (originalName != null && n && n !== String(originalName).trim()) {
    parts.push(t('renamedFrom', { name: originalName }))
  }
  if (originalType != null && type && type !== originalType) {
    parts.push(t('typeChangedFrom', { type: zoneTypeLabel(originalType) }))
  }
  if (!parts.length) return null
  // The stored figures are relabelled by the nightly run; today's live counts at once.
  return `${parts.join(' ')} ${t('historyNote')}`
}
